const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/tag');
const processError = require('./contentful/error-process');
const slug = require('slug');

module.exports = {
  async getOrCreateTagIdsFromTags(tags) {
    const allTags = await this.getAll();

    const newTags = tags.filter((predefinedTag) => !allTags.some((tag) => tag.id === slug(predefinedTag)));
    const tagsToAdd = allTags.filter((tag) => tags.some((predefinedTag) => tag.id === slug(predefinedTag)));

    // If we have any new tags that do not exist in Contentful
    if (newTags.length > 0) {
      const newlyCreatedTagPromises = newTags.map((tag) => {
        const newTag = this.create({
          id: slug(tag),
          name: tag
        });
        return newTag;
      });

      const newlyCreatedTags = await Promise.all(newlyCreatedTagPromises);

      // Add the new tags to the array of the ones we want to add that already exists.
      tagsToAdd.push(...newlyCreatedTags);
    }

    return tagsToAdd.map((tag) => tag.id);
  },


  getAll() {
    return getSpace().then((space) => {
      return space.getTags({
        limit: 1000
      }).catch(
        processError
      ).then((response) => {
        return response.toPlainObject();
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  },

  create(tag) {
    return getSpace().then((space) => {
      const tagID = tag.id !== 0 ? tag.id : slug(tag.name);
      return space.createTag(tagID, tag.name).then((entry) => {
        return entry.toPlainObject();
      }).then((data) => {
        return transformer.contentfulToInternal(data);
      });
    });
  }
};
